// extracted by mini-css-extract-plugin
export var logo = "_bx-2";
export var logoWrapper = "_bx-1";
export var strip = "_bx-0";